import { render, staticRenderFns } from "./CustomerTags.vue?vue&type=template&id=2c770936&scoped=true&"
import script from "./CustomerTags.vue?vue&type=script&lang=js&"
export * from "./CustomerTags.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTags.vue?vue&type=style&index=0&id=2c770936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c770936",
  null
  
)

export default component.exports